import { OrganizationReceiptRulesResponse } from 'src/models/organizations.models'
import { orgQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface QueryOrgReceiptRulesOptions
  extends ExtendBaseQueryOptions<
    {
      receiptRule?: OrganizationReceiptRulesResponse
      // These are included in the response but I dont know if they are used anywhere
      // So keeping them here for now, but leaving them out via the select function
      hasRecurringCards: boolean
      currencies: []
    },
    OrganizationReceiptRulesResponse | undefined
  > {
  orgId: string | undefined
}

export const useQueryOrgReceiptRules = ({
  orgId,
  enabled = true,
  ...rest
}: QueryOrgReceiptRulesOptions) => {
  return useExtendQuery({
    queryKey: orgQueryKeys.receiptRules(orgId),
    queryUrl: () => `/organizations/${orgId}/receiptrules`,
    enabled: enabled && orgId !== undefined,
    select: (data): OrganizationReceiptRulesResponse | undefined => {
      return data?.receiptRule
    },
    ...rest,
  })
}
